import { diffWords } from 'diff';

/** The visible text of a rich-text value, so a diff counts words, not markup. */
export function stripHtml(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
}

function countWords(value: string): number {
    return value.trim() === '' ? 0 : value.trim().split(/\s+/).length;
}

/** Added/removed word counts between two values — the diff's `+X / −X` stat. */
export function diffStats(
    oldValue: string,
    newValue: string,
    isHtml?: boolean
): { added: number; removed: number } {
    const oldText = isHtml ? stripHtml(oldValue) : oldValue;
    const newText = isHtml ? stripHtml(newValue) : newValue;
    let added = 0;
    let removed = 0;
    for (const part of diffWords(oldText, newText)) {
        if (part.added) {
            added += countWords(part.value);
        } else if (part.removed) {
            removed += countWords(part.value);
        }
    }
    return { added, removed };
}
